import { Tabs, Divider, Row } from '@bancobarigui/barihaus';

import { UserInfoForm } from '@/components/UserInfoForm';
import { RoleTransfer } from '@/components/RoleTransfer';
import { InspectionTypesTransfer } from '@/components/InspectionTypesTransfer';

import { RoleModuleType } from '@/shared/enums/RoleModuleType';

export function BankUserForm() {
  return (
    <>
      <UserInfoForm />

      <Divider>Configurações</Divider>

      <Row>Defina os itens que serão associados ao usuário.</Row>

      <Tabs
        items={[
          {
            key: '1',
            label: 'Perfil de Acesso',
            children: <RoleTransfer module={RoleModuleType.bank} />,
          },

          {
            key: '2',
            label: 'Tipos de Inspeção',
            children: <InspectionTypesTransfer />,
          },
        ]}
      />
    </>
  );
}
